import React, { useEffect } from "react";
import '../ChecklistDiario.scss'
import { Calendar } from "primereact/calendar";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";


const Filtros = ({
    fechaInicio,
    setFechaInicio,
    fechaFin,
    setFechaFin,
    globalFilter,
    setGlobalFilter,
    expandAll,
    collapseAll,
}) => {
    
    useEffect(() => { 
        setFechaInicio(new Date());
        setFechaFin(new Date());
    }, [])

    return (
        <div className="filtros">
            <Calendar dateFormat="dd/mm/yy" tooltip="Fecha inicio" tooltipOptions={{ position: 'bottom' }} value={fechaInicio} onChange={(e) => setFechaInicio(e.value)} showIcon />
            <Calendar dateFormat="dd/mm/yy" tooltip="Fecha fin" tooltipOptions={{ position: 'bottom' }} value={fechaFin} onChange={(e) => setFechaFin(e.value)} showIcon />
            <span className="p-input-icon-left">
               
                <InputText icon="pi pi-search" value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Buscar..." style={{ fontSize: 'small' }} />
            </span>
            <Button icon="pi pi-plus" label="Expandir todo" className="p-button-text p-button-sm" onClick={expandAll} style={{ fontSize: 'small' }} />
            <Button icon="pi pi-minus" label="Colapsar todo" className="p-button-text p-button-sm" onClick={collapseAll} style={{ fontSize: 'small' }} />
        </div>
    )
}
export default Filtros